const hamburgermenu = {
  name: 'hamburger-menu',
  viewBox: '0 0 44 32',
  paths: [
    {
      d: 'M3.2 0h37.6c1.767 0 3.2 1.433 3.2 3.2s-1.433 3.2-3.2 3.2h-37.6c-1.767 0-3.2-1.433-3.2-3.2s1.433-3.2 3.2-3.2z M3.2 12.8h37.6c1.767 0 3.2 1.433 3.2 3.2s-1.433 3.2-3.2 3.2h-37.6c-1.767 0-3.2-1.433-3.2-3.2s1.433-3.2 3.2-3.2z M3.2 25.6h37.6c1.767 0 3.2 1.433 3.2 3.2s-1.433 3.2-3.2 3.2h-37.6c-1.767 0-3.2-1.433-3.2-3.2s1.433-3.2 3.2-3.2z'
    }
  ]
};

export default hamburgermenu;
